module.exports = __webpack_public_path__ + "static/media/html_logo.fc4b15b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/html_logo.png
// module id = 407
// module chunks = 1